import { Flex } from '@theme-ui/components';
import Flags from 'country-flag-icons/react/3x2';
import { css } from '@emotion/react';

import LocationIcon from '@app/assets/icons/LocationIcon';
import { UnstyledButton } from '@app/components/Button';
import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

import type { Option } from './StoreSwitch';

type StoreSwitchButtonProps = {
  currentCountry?: Option;
  onClick: () => void;
};

const StoreSwitchButton = ({
  currentCountry,
  onClick,
}: StoreSwitchButtonProps) => {
  const SelectedFlag = Flags[currentCountry?.value ?? 0];

  return (
    <UnstyledButton
      data-testid="store-switch"
      onClick={onClick}
      css={css`
        min-width: ${rem(18)};
        cursor: pointer;
      `}
    >
      <Flex as="span" sx={{ alignItems: 'center' }}>
        <LocationIcon
          css={css`
            position: relative;
            left: ${rem(3)};
          `}
        />

        {SelectedFlag && (
          <SelectedFlag
            data-testid={`store-switch-country-${currentCountry?.value}`}
            alt={currentCountry?.label}
            css={css`
              width: ${rem(14)};
              height: 100%;
              border: 1px solid ${theme.colors.blueishGray};
            `}
          />
        )}
      </Flex>
    </UnstyledButton>
  );
};

export default StoreSwitchButton;
